export function obterListaMdfeTipoProprietario() {
  return (
    [
      { label: '00 - TAC Agregado', value: 'AGREGADO' },
      { label: '01 - TAC Independente', value: 'INDEPENDENTE' },
      { label: '02 - Outros', value: 'OUTROS' },
    ]
  );
}
